import React from "react";
import { BadgeDollarSign, Clock3, MousePointerClick, ShieldCheck, TrendingUp } from "lucide-react";
import { FEATURES } from "../mock";
import { Eyebrow } from "./Hero";

const ICONS = { dollar: BadgeDollarSign, clock: Clock3, shield: ShieldCheck, mouse: MousePointerClick, trending: TrendingUp };

export default function Features() {
  return (
    <section id="features" data-testid="features-section" className="relative py-14 md:py-16 sep-top">
      <div className="mx-auto max-w-5xl px-6 md:px-10">
        <div className="mb-10 text-center">
          <Eyebrow text={FEATURES.eyebrow} testId="features-eyebrow" />
          <h2 className="eyebrow-title-gap font-display text-3xl md:text-4xl" data-testid="features-heading" style={{ color: "#201850" }}>{FEATURES.heading}</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm md:text-base" data-testid="features-description" style={{ color: "rgba(32,24,80,0.7)" }}>{FEATURES.description}</p>
        </div>
        <div className="space-y-4">
          {FEATURES.items.map((item, index) => {
            const Icon = ICONS[item.icon];
            return (
              <article key={item.title} data-testid={`feature-${index + 1}`} className="card-light flex items-center gap-5 rounded-lg p-5 text-left md:gap-7 md:p-7">
                <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full" style={{ background: "rgba(0,168,232,0.12)", color: "#0090CC" }}>
                  <Icon className="h-7 w-7" aria-hidden="true" />
                </span>
                <div>
                  <h3 className="font-display text-base md:text-lg" data-testid={`feature-${index + 1}-title`} style={{ color: "#201850" }}>{item.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed md:text-base" data-testid={`feature-${index + 1}-body`} style={{ color: "rgba(32,24,80,0.72)" }}>{item.body}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}